package org.molap.dataframe

import kotlin.reflect.KClass

class Column<R, out V>(
    val type: KClass<*>,
    val values: (R) -> V
) {
    operator fun get(row: R): V = values(row)
}